import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { DoctorAct } from 'src/app/entities/act.entity/act';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { ServicesSharedService } from 'src/app/services/services-shared.service/services-shared.service';

@Component({
  selector: 'app-act-form',
  templateUrl: './doctor-act-form.component.html',
  styleUrls: ['./doctor-act-form.component.css']
})
export class DoctorActFormComponent implements OnInit {
 @Input() doctorAct: DoctorAct = new DoctorAct();
  @Input() doctor: Doctor = new Doctor();
  @Output() doctorActChange: EventEmitter<DoctorAct> = new EventEmitter();
  isSubmitted: boolean = false;
  infoCnam:boolean=false;
  get isValid(): boolean {
    return !isNaN(this.doctorAct.montant) && this.doctorAct.actes.desc_Acte.length > 0 ;
  }
  private sub!: Subscription;

  constructor(private sharedService: ServicesSharedService) {}

  ngOnInit(): void {
  
  }

  _change(): void {
    // 🔹 Calcul seulement
    this.sharedService.calculateSum(
      this.doctorAct.doctorPrice,
      this.doctorAct.clinicPrice
    );
      // 🔹 Le child écoute le total (UI only)
    this.sub = this.sharedService.sum$.subscribe(total => {
      this.doctorAct.montant = total;
    });
  }


}



